import { rem, spacing } from '@koaly/mixins';

const componentTokens = {
    avatar: {
        appearance: {
            default: {
                variant: {
                    default: {
                        fontFamily: '@self.tokens.fontFamily',
                        fontWeight: 'normal',
                        backgroundColor: '@self.tokens.backgroundPrimary',
                        iconColor: '@self.colors.primary.650',
                    },
                },
                size: {
                    default: {
                        fontSize: rem(18),
                        lineHeight: rem(16),
                    },
                },
            },
        },
    },
    container: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.tokens.backgroundPrimary',
                    },
                    secondary: {
                        backgroundColor: '@self.tokens.backgroundSecondary',
                    },
                },
            },
        },
    },
    button: {
        appearance: {
            default: {
                variant: {
                    primary: {
                        color: '@self.colors.primary.100',
                        backgroundColor: '@self.colors.primary.650',
                        backgroundColorHover: '@self.colors.primary.600',
                        backgroundColorFocus: '@self.colors.primary.650',
                        borderColorFocus: '@self.colors.primary.100',
                        // Prefix suffix
                        prefixSuffixColor: '@self.colors.primary.600',
                        prefixSuffixColorHover: '@self.colors.primary.600',
                        prefixSuffixColorFocus: '@self.colors.primary.600',
                        prefixSuffixBackgroundColor: '@self.colors.primary.100',
                        prefixSuffixBackgroundColorHover: '@self.colors.primary.100',
                        prefixSuffixBackgroundColorFocus: '@self.colors.primary.100',
                    },
                    secondary: {
                        color: '@self.colors.primary.650',
                        colorHover: '@self.colors.primary.100',
                        colorFocus: '@self.colors.primary.650',
                        backgroundColor: '@self.colors.primary.100',
                        backgroundColorHover: '@self.colors.primary.600',
                        backgroundColorFocus: '@self.colors.primary.100',
                        borderColorFocus: '@self.colors.primary.600',
                        // Prefix suffix
                        prefixSuffixColor: '@self.colors.primary.650',
                        prefixSuffixColorHover: '@self.colors.primary.600',
                        prefixSuffixColorFocus: '@self.colors.primary.650',
                        prefixSuffixBackgroundColor: '@self.colors.primary.200',
                        prefixSuffixBackgroundColorHover: '@self.colors.primary.100',
                        prefixSuffixBackgroundColorFocus: '@self.colors.primary.200',
                    },
                    danger: {
                        color: '@self.colors.danger.100',
                        backgroundColor: '@self.colors.danger.650',
                        backgroundColorHover: '@self.colors.danger.600',
                        backgroundColorFocus: '@self.colors.danger.650',
                        borderColorFocus: '@self.colors.danger.100',
                        // Prefix suffix
                        prefixSuffixColor: '@self.colors.danger.600',
                        prefixSuffixColorHover: '@self.colors.danger.600',
                        prefixSuffixColorFocus: '@self.colors.danger.600',
                        prefixSuffixBackgroundColor: '@self.colors.danger.100',
                        prefixSuffixBackgroundColorHover: '@self.colors.danger.100',
                        prefixSuffixBackgroundColorFocus: '@self.colors.primary.100',
                    },
                    disabled: {
                        disabledColor: '@self.colors.primary.400',
                        disabledBackgroundColor: '@self.colors.primary.200',
                    },
                    basic: {
                        borderColorFocus: '@self.colors.grey.700',
                        backgroundColor: '@self.colors.grey.200',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(40),
                    },
                    small: {
                        height: rem(40),
                        mobileHeight: rem(32),
                        prefixSuffixSpacing: rem(4),
                        prefixSuffixSize: rem(16),
                        paddingHorizontal: spacing(12),
                        mobilePaddingHorizontal: spacing(8),
                    },
                    medium: {
                        prefixSuffixSize: rem(20),
                        height: rem(52),
                        prefixSuffixSpacing: rem(8),
                        mobileHeight: rem(48),
                        paddingHorizontal: spacing(16),
                        mobilePaddingHorizontal: spacing(10),
                    },
                    large: {
                        prefixSuffixSize: rem(24),
                        prefixSuffixSpacing: rem(10),
                        height: rem(58),
                        mobileHeight: rem(52),
                        paddingHorizontal: spacing(20),
                        mobilePaddingHorizontal: spacing(12),
                    },
                },
            },
            cta: {
                size: {
                    small: {
                        prefixSuffixSize: rem(16),
                        prefixSuffixSpacing: rem(12),
                        prefixSuffixSpacingMobile: rem(10),
                        prefixSuffixCircleSize: rem(28),
                        prefixSuffixCircleMobileSize: rem(24),
                    },
                    medium: {
                        prefixSuffixSize: rem(20),
                        prefixSuffixCircleSize: rem(40),
                        prefixSuffixCircleMobileSize: rem(32),
                        prefixSuffixSpacing: rem(16),
                        prefixSuffixMobileSpacing: rem(12),
                    },
                    large: {
                        prefixSuffixSize: rem(24),
                        prefixSuffixSpacing: rem(20),
                        prefixSuffixSpacingMobile: rem(16),
                        prefixSuffixCircleSize: rem(48),
                        prefixSuffixCircleMobileSize: rem(40),
                    },
                },
            },
        },
    },
    iconButton: {
        appearance: {
            default: {
                variant: {},
                size: {
                    default: {
                        iconSize: rem(24),
                        iconSizeMobile: rem(16),
                    },
                    large: {
                        padding: `${spacing(10)}`,
                        mobilePadding: spacing(8),
                    },
                    medium: {
                        padding: spacing(8),
                        mobilePadding: spacing(6),
                    },
                    small: {
                        padding: spacing(4),
                        mobilePadding: spacing(3),
                    },
                },
            },
        },
    },
    statusMessages: {
        appearance: {
            default: {
                variant: {
                    danger: {
                        color: '@self.colors.danger.600',
                    },
                    info: {
                        color: '@self.colors.info.600',
                    },
                    success: {
                        color: '@self.colors.success.600',
                    },
                },
                size: {
                    default: {
                        iconSize: rem(20),
                    },
                },
            },
        },
    },
    input: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.colors.primary.1000',
                        borderColor: '@self.colors.primary.400',
                        borderColorFocus: '@self.colors.primary.650',
                        placeholderColor: '@self.colors.primary.700',
                        backgroundColor: '@self.colors.primary.100',
                        errorBorderColor: '@self.colors.danger.600',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(56),
                    },
                    large: {
                        padding: `${spacing(8)} ${spacing(12)}`,
                        mobilePadding: `${spacing(6)} ${spacing(10)}`,
                    },
                    medium: {
                        padding: `${spacing(6)} ${spacing(10)}`,
                        mobilePadding: `${spacing(6)} ${spacing(10)}`,
                    },
                },
            },
        },
    },
    // TopBar
    topBar: {
        appearance: {
            default: {
                variant: {
                    default: {
                        iconColor: '@self.tokens.textPrimaryColor',
                    },
                },
                size: {},
            },
        },
    },
    // Navigation
    navigation: {
        appearance: {
            default: {
                variant: {
                    default: {
                        linkColor: '@self.tokens.linkPrimaryColor',
                        linkColorHover: '@self.tokens.linkPrimaryColorHover',
                        linkColorActive: '@self.tokens.linkPrimaryColorActive',
                    },
                    secondary: {
                        linkColor: '@self.tokens.linkSecondaryColor',
                        linkColorHover: '@self.tokens.linkSecondaryColorHover',
                        linkColorActive: '@self.tokens.linkSecondaryColorActive',
                    },
                },
            },
            underlined: {
                variant: {
                    default: {
                        borderColorActive: '@self.tokens.navigationPrimaryBorderColorActive',
                    },
                    secondary: {
                        borderColorActive: '@self.tokens.navigationSecondaryBorderColorActive',
                    },
                },
                size: {
                    default: {
                        borderSize: rem(2),
                        borderSpacing: rem(8),
                    },
                },
            },
        },
    },
    // Tag
    tag: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.colors.primary.650',
                        color: '@self.colors.primary.100',
                    },
                },
                size: {
                    default: {
                        padding: `${spacing(2)} ${spacing(8)}`,
                        borderRadius: rem(40),
                        paddingWithIconButton: `${spacing(2)} ${spacing(14)} ${spacing(2)} ${spacing(8)}`,
                    },
                },
            },
        },
    },
    // Card
    card: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.colors.primary.500',
                        backgroundColor: '@self.colors.primary.100',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(20),
                        padding: `${spacing(16)}`,
                    },
                },
            },
        },
    },
    // Toast
    toast: {
        appearance: {
            default: {
                variant: {
                    danger: {
                        backgroundColor: '@self.colors.danger.200',
                        color: '@self.colors.danger.800',
                        leftBackgroundColor: '@self.colors.danger.400',
                        leftColor: '@self.colors.danger.800',
                    },
                    success: {
                        backgroundColor: '@self.colors.success.200',
                        color: '@self.colors.success.800',
                        leftBackgroundColor: '@self.colors.success.400',
                        leftColor: '@self.colors.success.800',
                    },
                    warning: {
                        backgroundColor: '@self.colors.warning.200',
                        color: '@self.colors.warning.800',
                        leftBackgroundColor: '@self.colors.warning.400',
                        leftColor: '@self.colors.warning.800',
                    },
                    info: {
                        backgroundColor: '@self.colors.info.200',
                        color: '@self.colors.info.800',
                        leftBackgroundColor: '@self.colors.info.400',
                        leftColor: '@self.colors.info.800',
                    },
                },
                size: {
                    default: {
                        gutter: rem(12),
                        borderRadius: rem(10),
                        minHeight: rem(50),
                    },
                },
            },
        },
    },
    // CookieBar
    cookieBar: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.colors.primary.100',
                        backgroundColor: '@self.colors.primary.650',
                    },
                },
                size: {
                    default: {
                        padding: spacing(16),
                    },
                },
            },
        },
    },
    // Link
    link: {
        appearance: {
            default: {
                variant: {
                    primary: {
                        color: '@self.tokens.linkPrimaryColor',
                        colorHover: '@self.tokens.linkPrimaryColorHover',
                    },
                    secondary: {
                        color: '@self.tokens.linkSecondaryColor',
                        colorHover: '@self.tokens.linkSecondaryColorHover',
                    },
                },
            },
        },
    },
    // Modal
    modal: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.colors.primary.100',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(20),
                        padding: spacing(32),
                        mobilePadding: spacing(16),
                    },
                },
            },
        },
    },
    // Checkbox
    checkbox: {
        appearance: {
            default: {
                variant: {
                    default: {
                        borderColor: '@self.colors.primary.400',
                        color: '@self.colors.primary.650',
                        colorChecked: '@self.colors.primary.100',
                        backgroundColorChecked: '@self.colors.primary.650',
                        backgroundColorDisabled: '@self.colors.primary.200',
                        colorCheckedDisabled: '@self.colors.primary.400',
                        borderColorFocus: '@self.colors.primary.600',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(4),
                        borderSizeFocus: rem(2),
                    },
                    medium: {
                        size: rem(20),
                    },
                    large: {
                        size: rem(28),
                    },
                },
            },
        },
    },
    sidebarNavigation: {
        appearance: {
            default: {
                variant: {
                    default: {
                        // Color
                        color: '@self.tokens.linkPrimaryColor',
                        colorActive: '@self.tokens.linkPrimaryColorActive',
                        colorHover: '@self.tokens.linkPrimaryColorHover',
                        // Icon Color
                        iconColor: '@self.colors.primary.500',
                        iconColorActive: '@self.colors.primary.600',
                        iconColorHover: '@self.colors.primary.600',
                        // Background color
                        backgroundColorActive: '@self.colors.primary.300',
                        backgroundColorHover: '@self.colors.primary.300',
                    },
                },
                size: {
                    default: {
                        padding: `${spacing(6)} ${spacing(12)} ${spacing(6)} ${spacing(24)}`,
                        iconPaddingRight: `${spacing(8)}`,
                        iconSize: 24,
                    },
                },
            },
        },
    },
    // SidebarNavigation
    cmsSidebarNavigation: {
        appearance: {
            default: {
                variant: {
                    default: {
                        mobileBackgroundColor: '@self.tokens.backgroundPrimary',
                        backgroundColor: '@self.tokens.backgroundPrimary',
                    },
                },
                size: {
                    default: {
                        padding: `${spacing(20)} 0`,
                        width: rem(285),
                    },
                },
            },
        },
    },
    // CMSTopBar
    cmsTopBar: {
        appearance: {
            default: {
                variant: {
                    default: {
                        linkColor: '@self.colors.primary.650',
                    },
                },
                size: {
                    default: {
                        height: rem(88),
                        padding: spacing(12),
                        avatarNavigationSpaceBetween: 6,
                        mobileHeight: rem(64),
                        mobilePadding: spacing(6),
                    },
                },
            },
        },
    },
    // CMSTopBar
    popover: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.colors.primary.100',
                    },
                },
                size: {
                    default: {
                        padding: spacing(12),
                        borderRadius: rem(20),
                    },
                },
            },
        },
    },
    // Box
    box: {
        appearance: {
            default: {
                variant: {
                    default: {
                        borderColor: '@self.colors.grey.400',
                    },
                },
                size: {
                    default: {
                        borderRadius: rem(20),
                    },
                },
            },
        },
    },
    // Fieldset
    fieldset: {
        appearance: {
            default: {
                variant: {
                    default: {
                        labelColor: '',
                    },
                },
                size: {
                    default: {},
                },
            },
        },
    },
    // Fieldset
    divider: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.colors.primary.300',
                    },
                },
                size: {
                    default: {},
                },
            },
        },
    },
    // Fieldset
    fileDropzone: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.tokens.backgroundPrimary',
                    },
                },
                size: {
                    default: {},
                },
            },
        },
    },
    // Fieldset
    footer: {
        appearance: {
            default: {
                variant: {
                    default: {
                        itemBorderColor: '@self.colors.primary.300',
                    },
                },
                size: {
                    default: {
                        itemBorderSize: '1px',
                        itemBorderRadius: '6px',
                    },
                },
            },
        },
    },
    openingHours: {
        appearance: {
            default: {
                variant: {
                    default: {
                        color: '@self.colors.primary.650',
                        activeColor: '@self.tokens.textPrimaryColor',
                        closedColor: '@self.colors.danger.650',
                    },
                },
                size: {},
            },
        },
    },
    drawer: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.tokens.backgroundPrimary',
                    },
                    secondary: {
                        backgroundColor: '@self.tokens.backgroundSecondary',
                    },
                },
            },
        },
    },
    hero: {
        appearance: {
            default: {
                variant: {
                    default: {
                        textAlign: 'left',
                        textAlignMobile: 'center',
                    },
                },
            },
            playful: {
                variant: {
                    default: {
                        textAlign: 'left',
                        textAlignMobile: 'left',
                    },
                },
            },
        },
    },
    dot: {
        appearance: {
            default: {
                variant: {
                    default: {
                        backgroundColor: '@self.tokens.backgroundPrimary',
                        color: '@self.tokens.textPrimaryColor',
                        fontFamily: '@self.tokens.fontFamily',
                    },
                    secondary: {
                        backgroundColor: '@self.tokens.backgroundSecondary',
                        color: '@self.tokens.textSecondaryColor',
                    },
                },
            },
        },
    },
};

export { componentTokens };
//# sourceMappingURL=components.js.map
